<template>
    <div id="login" :class="environment">

        <div class="box" v-show="!show_remember">
            <img class="logo" src="img/logo_new.png">
            <div class="title">{{ 'login.backoffice' | i18n }}</div>
            <div class="message error" v-show="error_message">{{error_message}}</div>
            <input type="text" name="username" v-model="input.username" :placeholder="$t( 'login.username' )" v-on:keyup.enter="login()" />
            <input type="password" name="password" v-model="input.password" :placeholder="$t( 'login.password' )" v-on:keyup.enter="login()" />

            <button type="button" v-on:click="login()">{{$t( 'login.login' )}}</button>

            <div @click="show_remember = !show_remember" class="remember">{{$t( 'login.rememberme' )}}</div>

            <div class="itw-logo"><a href="https://intowingroup.com/" target="_blank"><img src="/img/logo-intowin-grey1.png"/></a><span>Technological partner</span></div>

        </div>

        <div class="box" v-show="show_remember">
            <img class="logo" src="img/logo_new.png">
            <div class="subtitle">{{ 'login.backoffice_remember' | i18n }}</div>
            <div class="message error" v-show="error_message_remember">{{error_message_remember}}</div>
            <input type="text" name="username" v-model="input.remember" :placeholder="$t( 'login.username' )" v-on:keyup.enter="remember()" />

            <button type="button" v-on:click="remember()">{{$t( 'login.rememberme' )}}</button>

            <div @click="show_remember = !show_remember" class="remember">{{$t( 'login.back' )}}</div>

            <div class="itw-logo"><a href="https://intowingroup.com/" target="_blank"><img src="/img/logo-intowin-grey1.png"/></a><span>Technological partner</span></div>

        </div>

    </div>
</template>

<script>
    //import router from '@/router';
    import {Api} from '@/core/api.js';
    const api = new Api();

    import i18n from '@/i18n'

    export default {
        name: 'Login',
        data() {
            return {
                input: {
                    username: "",
                    password: "",
                    remember: ""
                },
                error_message: false,
                error_message_remember: false,
                show_remember: false,
                environment: process.env.VUE_APP_ENVIRONMENT
            }
        },
        methods: {
            login() {
                var validation = [];

                var username = this.input.username;
                var password = sha256( this.input.password );

                if( username.trim() == "" || username.trim().length <= 0 ) validation.push(false);
                if( password.trim() == "" || password.trim().length <= 0 ) validation.push(false);


                if( validation.indexOf(false) == -1 ) {
                    var self = this;
                    api.login( { username: username, password: password } ).then( function( response ){
                        if( response.status ) {
                            self.error_message = false;
                            self.$store.commit( "events/setEventsActive", response.data.events );
                            self.$store.commit('user/setAuthenticate', response.data );
                            localStorage.setItem( 'token', response.data.token );
                            
                            self.$store.dispatch( 'loadTablesRelationship' ).then( function(){
                            
                                if( typeof localStorage.redirect !== 'undefined' ){
                                    self.$router.push( localStorage.redirect );
                                    localStorage.removeItem( 'redirect' );
                                }
                                else{
                                    self.$router.push( '/' );
                                }
                            });
                        } else {
                            self.error_message = "Dades d'accés incorrectes";
                        }
                    });
                } else {
                    this.error_message = "Dades d'accés incorrectes";
                }
            },

            remember() {
                var username = this.input.remember;
                if( username.trim() != "" && username.trim().length > 0 ){
                    var self = this
                    api.post( 'remember', { username: username } ).then( function( response ){
                        if( response.status ) {
                            self.error_message_remember = "S'ha enviat un correu electrónic"
                            var message = document.getElementsByClassName( 'message' )[1].classList
                            message.remove( 'error' )
                            message.add( 'success' )
                            
                        } else {
                            self.error_message_remember = "Dades d'accés incorrectes"
                            var message = document.getElementsByClassName( 'message' )[1].classList
                            message.add( 'error' )
                            message.remove( 'success' )
                        }
                    });
                }
                else{
                    this.error_message_remember = "Indica un nom d'usuari vàlid";
                    var message = document.getElementsByClassName( 'message' )[1].classList
                    message.add( 'error' )
                    message.remove( 'success' )
                }
            },

            created() {
                this.$store.commit( 'user/setAuthenticate', false );

            }
        }
    }
</script>

<style lang="scss" scoped>
    #login {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 25px;
        background: $dark-color;

        &.development {
            top: $height-development;
        }

        .box {
            max-width: 275px;
            width: 100%;
            margin: 0 auto;

            width: 80%;
            height: 80%;
            overflow: auto;
            margin: auto;
            position: absolute;
            top: 0; left: 0; bottom: 0; right: 0;
            text-align: center;

            .logo {
                width: 100%;
                margin-bottom: 50px;
            }
            .title {
                color: $secondary-color;
                font-size: 24px !important;
                line-height: 24px !important;
                position: relative;
                width: 100%;
                margin: 0 0 30px 0;
            }
            .subtitle {
                color: $secondary-color;
                font-size: 16px !important;
                line-height: 24px !important;
                position: relative;
                width: 100%;
                margin: 0 0 30px 0;
            }

            .message {
                text-align: center;
                font-size: 18px;
                margin: 0 0 15px 0;
                padding: 5px 0;

                &.error {
                    border: 1px solid #c10c0c;
                    border-radius: 5px;
                    background-color: #e88383;
                    color: #FFF;
                }
                &.success {
                    border: 2px solid #087908;
                    border-radius: 5px;
                    background-color: #a0f8b6;
                    color: #000;
                }
            }

            input{
                width: 100%;
                padding: 15px;
                margin-bottom: 5px;
                border: 1px solid $secondary-color;
                outline: none;
                font-size: 11pt;
                border-radius: 3px;
                color: $secondary-color;
                //background: #ddd;
                //border: none;
                //border-left: 35px solid var(--main-color);
                //border-right: 35px solid var(--main-color);

                &:focus {
                    border: 1px solid $first-color;
                }

            }
            button {
                width: 100%;
                padding: 15px;
                outline: none;
                border: none;
                cursor: pointer;
                font-size: 12pt;
                font-family: Speedee-Bold;
                margin-top: 5px;
                border-radius: 3px;
                text-transform: uppercase;
                transition: all 0.5s;
                background: $secondary-color;
                color: $main-color;

                &:hover {
                    background: $first-color;
                    color: #fff;
                }
            }

            .remember {
                font-size: 10pt;
                margin-top: 20px;
                color: #888;
                cursor: pointer;
                display: block;
                text-decoration: none;

                &:hover {
                    text-decoration: underline;
                }
            }

            .itw-logo {
                width: 320px;
                margin: 0 auto;
                margin-top: 25px;
                display: block;
                position: fixed;
                bottom: 15%;
                left: 50%;
                margin-left: -160px;
                display: flex;
                align-items:center;

                img {
                    width: 160px;
                }
                span {
                    color: #888;
                    font-size: 14px;
                    margin-left: 10px;
                }
            }

        }
    }

    
</style>